<template>
  <body class="logoSection-body">
    <img
      class="image"
      src="../../../assets/company/Wecobi-orange.png"
      alt="wecobi-orange"
    />
    <div class="text">[ We Co Buy ]</div>
  </body>
</template>

<script>
export default {
  name: "LogoSection",
  components: {},
};
</script>

<style scoped>
.logoSection-body {
  width: 100%;
  height: auto;
  margin: 68px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.image {
  width: 350px;
}
.text {
  font-size: 35px;
  font-weight: 600;
  line-height: 1.2;
  color: #939393;
}

@media (max-width: 1024px) {
  .logoSection-body {
    margin: 49px 0px;
  }
  .image {
    width: 252px;
  }
  .text {
    font-size: 25px;
  }
}
</style>
